import { Record, List } from 'immutable';

export const defaultApiValues = {
  opcoId: null,
  opcoName: null,
  marketName: null,
  country: 'US',
};

// object dto with api
const OpcoDto = Record({ ...defaultApiValues });

/**
 * map list of objects which represents opco records into OpcoDto records
 * @param {Array} opcos list of objects which represents opco records
 * @returns list of records of CustomSizeDto records
 */
export const mapToRecords = rawObjects => {
  let opcos = new List();
  if (!rawObjects) {
    return opcos;
  }

  for (const record of rawObjects) {
    opcos = opcos.push(new OpcoDto(record));
  }

  return opcos;
};

export default OpcoDto;
